import { RECORD_TYPES } from "@/react/components/shared/CommunityMemberPicker/types";
import { appendQueryString } from "./appendQueryString";
import { postsPath } from "./posts";

type Params = Record<string, any>;

interface EntitiesParams {
  lesson_id?: number;
  params?: Params;
  section_id?: number;
  slug: string;
  space_slug: string;
  type: string;
}

export const entitiesPath = ({
  type,
  slug,
  space_slug,
  section_id,
  lesson_id,
  params = {},
}: EntitiesParams) => {
  if (type.toLowerCase() === RECORD_TYPES.SPACE) {
    return appendQueryString(`/c/${slug}`, params);
  }

  if (type.toLowerCase() === "lesson") {
    return appendQueryString(
      `/c/${space_slug}/sections/${section_id}/lessons/${lesson_id}`,
      params,
    );
  }

  return postsPath({ spaceSlug: space_slug, slug, params });
};
